// scroll to top
(function ($) {
	$(".back-to-top").click(function(e) {
		e.preventDefault();
		$("html, body").animate({ scrollTop: 0 }, 150);
		return false;
	});
})(jQuery);
